import React, { useEffect, useRef, useCallback } from 'react';
import Regex from '../../utils/regex';
import { Radio, Input, InputNumber, message } from 'antd';
import { Container, FieldTitle, RowSection } from './styles';
import { withTranslation } from 'react-i18next';
import { FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR } from './translationValues';

const NAMESPACES = ['FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR'];

const defaultGetElementDetails = el => el.elementDetails;

const FillableSettings = props => {
  const { element, style = {}, t, updateElementDetails, onFieldNameChange, OPTIONS_KEY = 'validations', FIELD_NAME_KEY = 'fieldName',
    MULTILINE_KEY = 'scroll', READ_ONLY_KEY = 'readOnly', MAX_CHARACTERS_KEY = 'maxLength', getElementDetails = defaultGetElementDetails } = props;
  const elementValidation = element? getElementDetails(element)[OPTIONS_KEY] : {};

  const forwardRef = useRef(null);
  const fieldNamRef = useRef(null);
  const maxCharRef = useRef(null);

  useEffect(() => {
    if (forwardRef.current) {
      forwardRef.current = null;
    } else { // Change from context
      const details = getElementDetails(element);
      if (fieldNamRef.current?.input) fieldNamRef.current.input.value = details[OPTIONS_KEY][FIELD_NAME_KEY];
      if (maxCharRef.current?.inputNumberRef?.input) {
        maxCharRef.current.inputNumberRef.input.value = details[OPTIONS_KEY][MAX_CHARACTERS_KEY];
      }
    }
  }, [element, getElementDetails]);

  const onTextInputChange = useCallback(e => {
    if (Regex.NO_SPLCHAR_EXCEPT_HYPHEN.test(e.target.value)) {
      message.error(
        t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.FIELD_NAME_SPECIAL_CHARACTER_ERROR_MESSAGE.value)
      );
      e.target.value = getElementDetails(element)[OPTIONS_KEY][FIELD_NAME_KEY];
    } else {
      forwardRef.current = e.target;
      onFieldNameChange(e.target.value);
    }
  }, [onFieldNameChange, element, getElementDetails]);

  const onMaxCharChange = useCallback(value => {
    if (parseInt(maxCharRef.current?.inputNumberRef?.currentValue) === value) return;
    forwardRef.current = maxCharRef.current;
    updateElementDetails(value, MAX_CHARACTERS_KEY);
  }, [updateElementDetails]);

  return (
    <Container style={style}>
      <FieldTitle isTitle={1}>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.TEXT_BOX_SETTINGS_TITLE.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.TEXT_BOX_SETTINGS_TITLE.value)}</FieldTitle>
      <RowSection>
        <FieldTitle>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.FIELD_NAME_LABEL.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.FIELD_NAME_LABEL.value)}*</FieldTitle>
        <Input
          ref={fieldNamRef}
          placeholder={t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.FIELD_NAME_PLACEHOLDER.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.FIELD_NAME_PLACEHOLDER.value)}
          onChange={onTextInputChange}
          defaultValue={elementValidation[FIELD_NAME_KEY]}
        />
      </RowSection>
      <RowSection>
        <FieldTitle>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.IS_MULTILINE_LABEL.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.IS_MULTILINE_LABEL.value)}</FieldTitle>
        <Radio.Group
          name="radiogroup"
          onChange={e => updateElementDetails(e.target.value === 1, MULTILINE_KEY)}
          value={elementValidation[MULTILINE_KEY] ? 1 : 2}
        >
          <Radio value={1}>
            {t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.MULTILINE_YES_SWITCH.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.MULTILINE_YES_SWITCH.value)}
          </Radio>
          <Radio value={2}>
            {t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.MULTILINE_NO_SWITCH.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.MULTILINE_NO_SWITCH.value)}
          </Radio>
        </Radio.Group>
      </RowSection>
      <RowSection>
        <FieldTitle>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.MAX_LENGTH_LABEL.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.MAX_LENGTH_LABEL.value)}</FieldTitle>
        <InputNumber
          ref={maxCharRef}
          defaultValue={elementValidation[MAX_CHARACTERS_KEY]}
          onChange={onMaxCharChange}
        />
      </RowSection>
      <RowSection>
        <FieldTitle>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.READ_ONLY_LABEL.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.READ_ONLY_LABEL.value)}</FieldTitle>
        <Radio.Group
          name="radiogroup"
          value={elementValidation[READ_ONLY_KEY] ? 7 : 8}
          onChange={e =>
            updateElementDetails(
              e.target.value === 7,
              READ_ONLY_KEY
            )
          }
        >
          <Radio value={7}>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.READ_ONLY_YES_SWITCH.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.READ_ONLY_YES_SWITCH.value)}</Radio>
          <Radio value={8}>{t(FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.READ_ONLY_NO_SWITCH.key, FILLABLE_ELEMENT_TEXTBOX_SETTINGS_SIDEBAR.READ_ONLY_NO_SWITCH.value)}</Radio>
        </Radio.Group>
      </RowSection>
    </Container>
  );
};

export default withTranslation(NAMESPACES)(FillableSettings);
